import React from "react";

// reactstrap components
import {
  Row,
  Col,
  Container,
} from "reactstrap";
import StackedTitle from "../pages/layout/StackedTitle";

const contactTitleGroups = [
  [{ text: "CONTACT US", tone: "accent" }],
];

class ContactUS extends React.Component {
  constructor() {
    super();
    this.state = {
      width: window.innerWidth,
    };
  }
  componentWillMount() {
    window.addEventListener("resize", this.handleWindowSizeChange);
  }

  // make sure to remove the listener
  // when the component is not mounted anymore
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  styleChange = () => {
    const isMobile = this.state.width <= 500;
    if (isMobile) {
      return (
        <section
          className="contact-us-section--image-right section-created-mobile section-contactus section-shaped contact-us-section"
        >
          <Container className="d-flex pd-0">
            <div className="col">
              <Row className="justify-content-between">
                <div className="mr-sm">
                  <StackedTitle groups={contactTitleGroups} />
                  <div className="pt-4 contact-us-office-item">
                    <i
                      className="fa fa-building-o contact-us-office-icon"
                      aria-hidden="true"
                    />
                    <div>
                      <span className="description-Normal-footer contact-us-office-heading">
                        SINGAPORE HEADQUARTER
                      </span>
                      <br />
                      <span className="description-Normal-footer">
                        HM GLOBAL HOLDINGS PTE. LTD.
                      </span>
                    </div>
                  </div>
                  <div className="my-4 contact-us-office-item">
                    <i
                      className="fa fa-handshake-o contact-us-office-icon"
                      aria-hidden="true"
                    />
                    <div>
                      <span className="description-Normal-footer contact-us-office-heading">
                        AFFILIATES
                      </span>
                      <br />

                      <Row className="align-items-top row-grid-contact">
                        <Col md="6" className="description-Small-footer">
                          PT. LEO JAYA GROUP
                        </Col>
                        <Col md="6" className="description-Small-footer">
                          TEMBUSU PARTNERS
                        </Col>
                      </Row>
                      <Row className="align-items-top row-grid-contact">
                        <Col md="6" className="description-Small-footer">
                          PT. MANDARA ASTA NUSANTARA
                        </Col>
                        <Col md="6" className="description-Small-footer">
                          PT. MAJU BERSAMA GEMILANG
                        </Col>
                      </Row>
                      <Row className="align-items-top row-grid-contact">
                        <Col md="6" className="description-Small-footer">
                          RAWABI OIL & GAS
                        </Col>
                        <Col md="6" className="description-Small-footer">
                          OODA KOREA
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <p className="description-Normal-footer">
                    SINGAPORE | SOUTH KOREA | INDONESIA | VIETNAM | JAPAN | USA | CHINA | MIDDLE EAST
                  </p>
                </div>
                <div
                  className="d-flex align-items-center shape-container"
                  style={{ marginTop: "5%" }}
                >
                  <div>
                      <p className="contactus-email">
                      Email: info@hmssg.co
                    </p>
                  </div>
                </div>
              </Row>
            </div>
          </Container>
        </section>
      );
      } else {
        return (
          <section
            className="contact-us-section--image-right section section-contactus section-shaped contact-us-section"
          >
          <Container className="d-flex">
            <div className="px-0 col">
              <Row className="align-items-top justify-content-between row-grid">
                <Col md="6" className="pt-2 contact-us-primary-column">
                    <div className="contener-content">
                      <StackedTitle groups={contactTitleGroups} />
                      <span className="contactus-email">
                      Email: info@hmssg.co
                    </span>
                  </div>
                </Col>
                <Col md="1" className="contact-us-divider-column">
                  <div className="right-line" />
                </Col>
                <Col md="5" className="py-sm">
                  <div className="contact-us-office-item">
                    <i
                      className="fa fa-building-o contact-us-office-icon"
                      aria-hidden="true"
                    />
                    <div>
                      <span className="description-Normal-footer contact-us-office-heading">
                        SINGAPORE HEADQUARTER
                      </span>
                      <br />
                      <span className="description-Normal-footer">
                        HM GLOBAL HOLDINGS PTE. LTD.
                      </span>
                    </div>
                  </div>

                  <div className="my-4 contact-us-office-item">
                    <i
                      className="fa fa-handshake-o contact-us-office-icon"
                      aria-hidden="true"
                    />
                    <div>
                      <span className="description-Normal-footer contact-us-office-heading">
                        AFFILIATES
                      </span>

                      <Row className="align-items-top row-grid-contact">
                        <Col md="6" className="description-Small-footer">
                          PT. LEO JAYA GROUP
                        </Col>
                        <Col md="6" className="description-Small-footer">
                          TEMBUSU PARTNERS
                        </Col>
                      </Row>
                      <Row className="align-items-top row-grid-contact">
                        <Col md="6" className="description-Small-footer">
                          PT. MANDARA ASTA NUSANTARA
                        </Col>
                        <Col md="6" className="description-Small-footer">
                          PT. MAJU BERSAMA GEMILANG
                        </Col>
                      </Row>
                      <Row className="align-items-top row-grid-contact">
                        <Col md="6" className="description-Small-footer">
                          RAWABI OIL & GAS
                        </Col>
                        <Col md="6" className="description-Small-footer">
                          OODA KOREA
                        </Col>
                      </Row>
                    </div>
                  </div>

                  <div>
                      <span className="description-Small-footer">
                      SINGAPORE | SOUTH KOREA | INDONESIA | VIETNAM | JAPAN | USA | CHINA | MIDDLE EAST
                    </span>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
      );
    }
  };
  render() {
    return (
      <>
        <main id="contact-us">{this.styleChange()}</main>
      </>
    );
  }
}

export default ContactUS;
